import { get, post, put } from './request';

export function create(json, callback = () => { }) {
  return (dispatch, getState) => {
    dispatch({
      type: 'VLF_CATEGORY_CREATE'
    });

    post(`vlf_category`, { json }).then(
      result => {
        if (!result.response.ok) {
          callback(result.json);
          dispatch({ type: 'VLF_CATEGORY_ERROR', error: result.response.statusText });
        } else {
          callback(null, result.json);
          dispatch({ type: 'VLF_CATEGORY_CREATE_OK', vlfCategory: result.json });
        }
      }).catch(error => dispatch({ type: 'VLF_CATEGORY_CREATE_ERROR', error }));
  };
}

export function update(_id, json, callback = () => { }) {
  return (dispatch, getState) => {
    dispatch({
      type: 'VLF_CATEGORY_UPDATE'
    });

    put(`vlf_category/${_id}`, { json }).then(
      result => {
        if (!result.response.ok) {
          callback(result.json);
          dispatch({ type: 'VLF_CATEGORY_ERROR', error: result.response.statusText });
        } else {
          callback(null, result.json);
          dispatch({ type: 'VLF_CATEGORY_UPDATE_OK', vlfCategory: result.json });
        }
      }).catch(error => dispatch({ type: 'VLF_CATEGORY_UPDATE_ERROR', error }));
  };
}

export function find(_id, callback = () => { }) {
  return (dispatch, getState) => {
    dispatch({
      type: 'VLF_CATEGORY_GET'
    });

    get(`vlf_category/${_id}`, { json: true }).then(
      result => {
        if (!result.response.ok) {
          callback(result.json);
          dispatch({ type: 'VLF_CATEGORY_ERROR', error: result.response.statusText });
        } else {
          callback(null, result.json);
          dispatch({ type: 'VLF_CATEGORY_GET_OK', vlfCategory: result.json });
        }
      }).catch(error => dispatch({ type: 'VLF_CATEGORY_GET_ERROR', error }));
  };
}

export function all(kwargs = {}, callback = () => { }) {
  return (dispatch) => {
    dispatch({
      type: 'VLF_CATEGORIES_GET'
    });

    const q = kwargs.q ? `&q=${kwargs.q}` : '';
    const limit = `?limit=${kwargs.limit || 20}`;
    get(`vlf_categories${limit}${q}`, { json: true }).then(
      result => {
        if (!result.response.ok) {
          callback(result.json);
          dispatch({ type: 'VLF_CATEGORY_ERROR', error: result.response.statusText });
        } else {
          callback(null, result.json);
          dispatch({ type: 'VLF_CATEGORIES_GET_OK', data: result.json });
        }
      }).catch(error => dispatch({ type: 'VLF_CATEGORIES_GET_ERROR', error }));
  };
}

